import BasicLayout from '@/layouts/BasicLayout'
import CustomStyleLayout from '@/layouts/CustomStyleLayout'

// meta 部分说明
// 如 meta: { title: '用户管理', permission: 'users', menu: 'users' }
// permission 用于权限控制，api 返回的权限列表中有 users 才可以访问
// menu       用于菜单选中高亮，如果不是菜单则可以不传值，值需要和 a-menu-item key="users" 的key值相同
// title      用于浏览器 tab 显示以及面包屑显示
//            - 以 ':' 开头的 title 为动态的值占位符, 用作业务逻辑中的值替换
//              可使用 SetDynamicBreadCrumbsPlaceholder 方法替换占位符的值, 如：
//              this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':agent_name': '客户1' })
//            - 还提供了 ConcatDynamicBreadCrumbs 方法追加面包屑, 常用于面包屑生成规则不统一，自行生成面包屑

// 异步路由(需要走权限控制)
export const asyncRouter = [
  // example
  {
    path: '/carrier_accounts',
    component: BasicLayout,
    meta: { title: '运营商账户', menu: 'carrier_accounts' },
    children: [
      {
        path: '',
        name: 'carrier_accounts',
        component: () => import('@/views/carrier_accounts/index.vue'),
        meta: { permission: 'carrier_accounts' }
      },
      {
        path: ':id',
        component: () => import('@/views/carrier_accounts/ShowTab.vue'),
        meta: { title: ':carrier_account_name' },
        children: [
          {
            path: 'info',
            name: 'carrier_account_info',
            component: () => import('@/views/carrier_accounts/Show.vue'),
            meta: { permission: 'carrier_accounts/show' }
          },
          {
            path: 'products',
            name: 'carrier_account_products',
            component: () => import('@/views/carrier_products/index.vue'),
            meta: { permission: 'carrier_products' }
          },
          {
            path: 'sim_cards',
            name: 'carrier_sim_cards',
            component: () => import('@/views/sim_cards/carrier/index'),
            meta: { permission: 'carrier_sim_cards' }
          },
          {
            path: 'sms_templates',
            name: 'carrier_sms_templates',
            component: () => import('@/views/sms_templates/carrier/index'),
            meta: { permission: 'carrier_sms_templates' }
          }
        ]
      }
    ]
  },
  {
    path: '/esim_suppliers',
    component: BasicLayout,
    meta: { title: 'eSIM供应商', menu: 'esim_suppliers' },
    children: [
      {
        path: '',
        name: 'esim_suppliers',
        component: () => import('@/views/esim_suppliers/index.vue'),
        meta: { permission: 'esim_suppliers' }
      },
      {
        path: ':id',
        component: () => import('@/views/esim_suppliers/ShowTab.vue'),
        meta: { title: ':esim_supplier_name' },
        children: [
          {
            path: 'info',
            name: 'esim_supplier_info',
            component: () => import('@/views/esim_suppliers/Show.vue'),
            meta: { permission: 'esim_suppliers/show' }
          },
          {
            path: 'esims',
            name: 'esim_supplier_esims',
            component: () => import('@/views/esims/supplier/index.vue'),
            meta: { permission: 'esim_supplier_esims' }
          }
        ]
      }
    ]
  },
  {
    path: '/profile_suppliers',
    component: BasicLayout,
    meta: { title: 'Profile供应商', menu: 'profile_suppliers' },
    children: [
      {
        path: '',
        name: 'profile_suppliers',
        component: () => import('@/views/profile_suppliers/index.vue'),
        meta: { permission: 'profile_suppliers' }
      },
      {
        path: ':id',
        component: () => import('@/views/profile_suppliers/ShowTab.vue'),
        meta: { title: ':profile_supplier_name' },
        children: [
          {
            path: 'info',
            name: 'profile_supplier_info',
            component: () => import('@/views/profile_suppliers/Show.vue'),
            meta: { permission: 'profile_suppliers/show' }
          },
          {
            path: 'profiles',
            name: 'profile_supplier_profiles',
            component: () => import('@/views/profiles/supplier/index.vue'),
            meta: { permission: 'profile_supplier_profiles' }
          }
        ]
      }
    ]
  },
  {
    path: '/module_suppliers',
    component: BasicLayout,
    meta: { title: '模组供应商', menu: 'module_suppliers' },
    children: [
      {
        path: '',
        name: 'module_suppliers',
        component: () => import('@/views/module_suppliers/index.vue'),
        meta: { permission: 'module_suppliers' }
      },
      {
        path: ':id',
        component: () => import('@/views/module_suppliers/ShowTab.vue'),
        meta: { title: ':module_supplier_name' },
        children: [
          {
            path: 'info',
            name: 'module_supplier_info',
            component: () => import('@/views/module_suppliers/Show.vue'),
            meta: { permission: 'module_suppliers/show' }
          },
          {
            path: 'modules',
            name: 'module_supplier_modules',
            component: () => import('@/views/modules/supplier/index.vue'),
            meta: { permission: 'module_supplier_modules' }
          }
        ]
      }
    ]
  },
  {
    path: '/cpe_suppliers',
    component: BasicLayout,
    meta: { title: 'CPE供应商', menu: 'cpe_suppliers' },
    children: [
      {
        path: '',
        name: 'cpe_suppliers',
        component: () => import('@/views/cpe_suppliers/index.vue'),
        meta: { permission: 'cpe_suppliers' }
      },
      {
        path: ':id',
        component: () => import('@/views/cpe_suppliers/ShowTab.vue'),
        meta: { title: ':cpe_supplier_name' },
        children: [
          {
            path: 'info',
            name: 'cpe_supplier_info',
            component: () => import('@/views/cpe_suppliers/Show.vue'),
            meta: { permission: 'cpe_suppliers/show' }
          },
          {
            path: 'models',
            name: 'cpe_supplier_models',
            component: () => import('@/views/cpe_supplier_models/index.vue'),
            meta: { permission: 'cpe_supplier_models' }
          },
          {
            path: 'cpes',
            name: 'cpe_supplier_cpes',
            component: () => import('@/views/cpes/supplier/index.vue'),
            meta: { permission: 'cpe_supplier_cpes' }
          }
        ]
      }
    ]
  },
  {
    path: '/switch_user',
    name: 'switch_user',
    component: () => import('@/views/switch_user/index')
  },
  {
    path: '/sale_monthly_performances',
    component: BasicLayout,
    meta: { title: '销售业绩', menu: 'sale_monthly_performances' },
    children: [
      {
        path: '',
        name: 'sale_monthly_performances',
        component: () => import('@/views/sale_monthly_performances/index'),
        meta: { permission: 'sale_monthly_performances' }
      },
      {
        path: 'by_month',
        name: 'sale_monthly_performance_by_month',
        component: () => import('@/views/sale_monthly_performances/admin/ByMonthList'),
        meta: { permission: 'sale_monthly_performances/by_month', title: ':month' }
      }
    ]
  },
  {
    path: '/sale_monthly_performances',
    component: CustomStyleLayout,
    meta: { title: '销售业绩', menu: 'sale_monthly_performances' },
    children: [
      {
        path: ':id',
        name: 'sale_monthly_performance_info',
        component: () => import('@/views/sale_monthly_performances/Show'),
        meta: { permission: 'sale_monthly_performances/show' }
      }
    ]
  },
  {
    path: '/finance_ledger',
    component: BasicLayout,
    meta: { title: '出入账管理', menu: 'finance_ledger' },
    children: [
      {
        path: '',
        name: 'finance_ledger',
        redirect: 'transfers',
        component: () => import('@/views/finance_ledger/ShowTab.vue'),
        meta: { permission: 'finance_ledger' },
        children: [
          {
            path: 'transfers',
            name: 'finance_ledger_transfers',
            component: () => import('@/views/finance_ledger/Transfers.vue'),
            meta: { permission: 'finance_ledger/transfers', title: '收付款记录', menu: 'finance_ledger' }
          },
          {
            path: 'open_channel_payments',
            name: 'finance_ledger_open_channel_payments',
            component: () => import('@/views/finance_ledger/OpenChannelPayments.vue'),
            meta: { permission: 'finance_ledger/open_channel_payments', title: '开放渠道支付', menu: 'finance_ledger' }
          }
        ]
      }
    ]
  },
  {
    path: '/sim_card_month_costs',
    redirect: '/cost_management'
  },
  {
    path: '/cost_accounting',
    redirect: '/cost_management'
  },
  {
    path: '/cost_management',
    component: BasicLayout,
    meta: { title: '成本管理', menu: 'sim_card_month_costs' },
    children: [
      {
        path: '',
        name: 'cost_management',
        redirect: 'statistics',
        component: () => import('@/views/sim_card_month_costs/ShowTab.vue'),
        meta: { permission: 'sim_card_month_costs' },
        children: [
          {
            path: 'statistics',
            name: 'cost_management_statistics',
            component: () => import('@/views/sim_card_month_costs/Statistics.vue'),
            meta: { permission: 'sim_card_month_costs', title: '卡成本统计', menu: 'sim_card_month_costs' }
          },
          {
            path: 'details',
            name: 'cost_management_details',
            component: () => import('@/views/sim_card_month_costs/index.vue'),
            meta: { permission: 'sim_card_month_costs', title: '卡成本明细', menu: 'sim_card_month_costs' }
          },
          {
            path: 'sim_cards',
            redirect: { name: 'cost_management_details' }
          }
        ]
      }
    ]
  },
  {
    path: '/order_summary',
    component: BasicLayout,
    meta: { title: '订单汇总', menu: 'order_summary' },
    children: [
      {
        path: '',
        name: 'order_summary',
        redirect: 'finance_orders',
        component: () => import('@/views/order_summary/ShowTab.vue'),
        meta: { permission: 'order_summary' },
        children: [
          {
            path: 'finance_orders',
            name: 'order_summary_finance_orders',
            component: () => import('@/views/order_summary/FinanceOrders.vue'),
            meta: { permission: 'order_summary/finance_orders', title: '财务订单' }
          },
          {
            path: 'commission_orders',
            name: 'order_summary_commission_orders',
            component: () => import('@/views/order_summary/CommissionOrders.vue'),
            meta: { permission: 'order_summary/commission_orders', title: '分佣订单' }
          }
        ]
      }
    ]
  },
  {
    path: '/sales_inventory_check',
    component: BasicLayout,
    meta: { title: '销售核库', menu: 'sales_inventory_check' },
    children: [
      {
        path: '',
        name: 'sales_inventory_check',
        redirect: 'modules',
        component: () => import('@/views/sales_inventory_check/ShowTab.vue'),
        meta: { permission: 'sales_inventory_check' },
        children: [
          {
            path: 'sim_cards',
            name: 'sales_inventory_check_sim_cards',
            component: () => import('@/views/sales_inventory_check/SimCards.vue'),
            meta: { permission: 'sales_inventory_check/sim_cards', title: 'SIM卡核库' }
          },
          {
            path: 'modules',
            name: 'sales_inventory_check_modules',
            component: () => import('@/views/sales_inventory_check/Modules.vue'),
            meta: { permission: 'sales_inventory_check/modules', title: '模组核库' }
          },
          {
            path: 'cpes',
            name: 'sales_inventory_check_cpes',
            component: () => import('@/views/sales_inventory_check/Cpes.vue'),
            meta: { permission: 'sales_inventory_check/cpes', title: 'CPE核库' }
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '',
        component: () => import('@/views/agent_statistics/ShowTab.vue'),
        meta: { title: '客户统计' },
        children: [
          {
            path: 'agent_statistics_finance',
            name: 'agent_statistics_finance',
            component: () => import('@/views/agent_statistics/Finance.vue'),
            meta: { permission: 'agent_statistics' }
          },
          {
            path: 'agent_statistics_order',
            name: 'agent_statistics_order',
            component: () => import('@/views/agent_statistics/Order.vue'),
            meta: { permission: 'agent_statistics' }
          },
          {
            path: 'agent_statistics_card',
            name: 'agent_statistics_card',
            component: () => import('@/views/agent_statistics/Card.vue'),
            meta: { permission: 'agent_statistics' }
          }
        ]
      }
    ]
  },
  {
    path: '/sim_card_inventories',
    component: BasicLayout,
    meta: { title: '卡资源入库', menu: 'sim_card_inventories' },
    children: [
      {
        path: '',
        component: () => import('@/views/sim_card_inventories/ShowTab.vue'),
        meta: { permission: 'sim_card_inventories' },
        children: [
          {
            path: '',
            name: 'sim_card_inventories',
            component: () => import('@/views/sim_card_inventories/index.vue'),
            meta: { permission: 'sim_card_inventories' }
          },
          {
            path: 'statistics/china_mobile',
            name: 'sim_card_inventory_statistics_china_mobile',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '中国移动库存统计', carrier_type: 'china_mobile' }
          },
          {
            path: 'statistics/china_unicom',
            name: 'sim_card_inventory_statistics_china_unicom',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '中国联通库存统计', carrier_type: 'china_unicom' }
          },
          {
            path: 'statistics/china_telecom',
            name: 'sim_card_inventory_statistics_china_telecom',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '中国电信库存统计', carrier_type: 'china_telecom' }
          },
          {
            path: 'statistics/china_broadnet',
            name: 'sim_card_inventory_statistics_china_broadnet',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '中国广电库存统计', carrier_type: 'china_broadnet' }
          },
          {
            path: 'statistics/mix_carrier',
            name: 'sim_card_inventory_statistics_mix_carrier',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '融合运营商库存统计', carrier_type: 'mix_carrier' }
          },
          {
            path: 'statistics/international_carrier',
            name: 'sim_card_inventory_statistics_international_carrier',
            component: () => import('@/views/sim_card_inventories/statistics/index.vue'),
            meta: { permission: 'sim_card_inventories', title: '国际运营商库存统计', carrier_type: 'international_carrier' }
          }
        ]
      }
    ]
  },
  {
    path: '/esim_inventories',
    component: BasicLayout,
    meta: { title: 'eSIM资源入库', menu: 'esim_inventories' },
    children: [
      {
        path: '',
        component: () => import('@/views/esim_inventories/ShowTab.vue'),
        meta: { permission: 'esim_inventories' },
        children: [
          {
            path: '',
            name: 'esim_inventories',
            component: () => import('@/views/esim_inventories/index.vue'),
            meta: { permission: 'esim_inventories' }
          },
          {
            path: 'import_records',
            name: 'esim_inventory_import_records',
            component: () => import('@/views/esim_inventories/import_records/index.vue'),
            meta: { permission: 'esim_inventories', title: '入库记录' }
          }
        ]
      }
    ]
  },
  {
    path: '/profile_inventories',
    component: BasicLayout,
    meta: { title: 'Profile资源入库', menu: 'profile_inventories' },
    children: [
      {
        path: '',
        component: () => import('@/views/profile_inventories/ShowTab.vue'),
        meta: { permission: 'profile_inventories' },
        children: [
          {
            path: '',
            name: 'profile_inventories',
            component: () => import('@/views/profile_inventories/index.vue'),
            meta: { permission: 'profile_inventories' }
          },
          {
            path: 'import_records',
            name: 'profile_inventory_import_records',
            component: () => import('@/views/profile_inventories/import_records/index.vue'),
            meta: { permission: 'profile_inventories', title: '入库记录' }
          },
          {
            path: 'profile_datas',
            name: 'profile_datas',
            component: () => import('@/views/profile_datas/index.vue'),
            meta: { permission: 'profile_datas', title: 'ProfileData资源' }
          }
        ]
      }
    ]
  },
  {
    path: '/module_inventories',
    component: BasicLayout,
    meta: { title: '模组资源入库', menu: 'module_inventories' },
    children: [
      {
        path: '',
        component: () => import('@/views/module_inventories/ShowTab.vue'),
        meta: { permission: 'module_inventories' },
        children: [
          {
            path: '',
            name: 'module_inventories',
            component: () => import('@/views/module_inventories/index.vue'),
            meta: { permission: 'module_inventories' }
          },
          {
            path: 'import_records',
            name: 'module_inventory_import_records',
            component: () => import('@/views/module_inventories/import_records/index.vue'),
            meta: { permission: 'module_inventories', title: '入库记录' }
          },
          {
            path: 'statistics',
            name: 'module_inventory_statistics',
            component: () => import('@/views/module_inventories/statistics/index.vue'),
            meta: { permission: 'module_inventories', title: '库存统计' }
          }
        ]
      }
    ]
  },
  {
    path: '/cpe_inventories',
    component: BasicLayout,
    meta: { title: 'CPE资源入库', menu: 'cpe_inventories' },
    children: [
      {
        path: '',
        component: () => import('@/views/cpe_inventories/ShowTab.vue'),
        meta: { permission: 'cpe_inventories' },
        children: [
          {
            path: '',
            name: 'cpe_inventories',
            component: () => import('@/views/cpe_inventories/index.vue'),
            meta: { permission: 'cpe_inventories' }
          },
          {
            path: 'statistics',
            name: 'cpe_inventory_statistics',
            component: () => import('@/views/cpe_inventories/statistics/index.vue'),
            meta: { permission: 'cpe_inventories', title: '库存统计' }
          }
        ]
      }
    ]
  },
  {
    path: '/batch_operation_records',
    component: BasicLayout,
    meta: { title: '批量操作查询', menu: 'batch_operation_records' },
    children: [
      {
        path: '',
        name: 'batch_operation_records',
        component: () => import('@/views/batch_operation_records/index.vue'),
        meta: { permission: 'batch_operation_records' }
      }
    ]
  },
  {
    path: '/batch_operation_records',
    component: CustomStyleLayout,
    meta: { title: '批量操作查询', menu: 'batch_operation_records' },
    children: [
      {
        path: ':id/info',
        name: 'batch_operation_record_info',
        component: () => import('@/views/batch_operation_records/detail/index.vue'),
        meta: { title: '批量操作详情', permission: 'batch_operation_records/show' }
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '',
        component: () => import('@/views/sim_card_carrier_tasks/ShowTab.vue'),
        meta: { title: '接口调用查询' },
        children: [
          {
            path: 'sim_card_carrier_tasks',
            name: 'sim_card_carrier_tasks',
            component: () => import('@/views/sim_card_carrier_tasks/index.vue'),
            meta: { menu: 'sim_card_carrier_tasks', permission: 'sim_card_carrier_tasks' }
          }
        ]
      }
    ]
  },
  {
    path: '/card_types',
    component: BasicLayout,
    meta: { title: '卡板管理', menu: 'card_types' },
    children: [
      {
        path: '',
        name: 'card_types',
        component: () => import('@/views/card_types/index.vue'),
        meta: { permission: 'card_types' }
      }
    ]
  },
  {
    path: '/industry_types',
    component: BasicLayout,
    meta: { title: '行业管理', menu: 'industry_types' },
    children: [
      {
        path: '',
        name: 'industry_types',
        component: () => import('@/views/industry_types/index.vue'),
        meta: { permission: 'industry_types' }
      }
    ]
  },
  {
    path: '/device_types',
    component: BasicLayout,
    meta: { title: '设备管理', menu: 'device_types' },
    children: [
      {
        path: '',
        name: 'device_types',
        component: () => import('@/views/device_types/index.vue'),
        meta: { permission: 'device_types' }
      }
    ]
  },
  {
    path: '/common_types',
    component: BasicLayout,
    meta: { title: '通用类型管理', menu: 'common_types' },
    children: [
      {
        path: '',
        name: 'common_types',
        component: () => import('@/views/common_types/index.vue'),
        meta: { permission: 'common_types' }
      }
    ]
  },
  {
    path: '/sales_quotes',
    component: BasicLayout,
    meta: { title: '销售报价', menu: 'sales_quotes' },
    children: [
      {
        path: '',
        name: 'sales_quotes',
        component: () => import('@/views/sales_quotes/index.vue'),
        meta: { permission: 'sales_quotes' }
      }
    ]
  },
  {
    path: '/agents',
    component: BasicLayout,
    meta: { title: '客户列表', menu: 'agents' },
    children: [
      {
        path: '',
        name: 'agents',
        component: () => import('@/views/agents/index.vue'),
        meta: { permission: 'agents' }
      },
      {
        path: ':id',
        component: () => import('@/views/agents/ShowTab.vue'),
        meta: { title: ':agent_name' },
        children: [
          {
            path: '',
            component: () => import('@/views/agents/info/Tab.vue'),
            children: [
              {
                path: 'info',
                name: 'agent_info',
                component: () => import('@/views/agents/info/index.vue'),
                meta: { permission: 'agents/show' }
              },
              {
                path: 'setting',
                name: 'agent_setting',
                component: () => import('@/views/agents/info/Setting.vue'),
                meta: { permission: 'agents/setting' }
              },
              {
                path: 'vpdn_manage',
                name: 'agent_vpdn_manage',
                component: () => import('@/views/agents/info/vpdn_manage/index.vue'),
                meta: { permission: 'agents/vpdn_manage' }
              },
              {
                path: 'vpdn_manage/:vpdn_manage_id',
                name: 'agent_vpdn_manage_info',
                component: () => import('@/views/agents/info/vpdn_manage/Detail.vue'),
                meta: { permission: 'agents/vpdn_manage' }
              },
              {
                path: 'api_info',
                name: 'agent_api_info',
                component: () => import('@/views/agents/info/Api'),
                meta: { permission: 'agents/api_info' }
              },
              {
                path: 'enterprise_qualification',
                name: 'agent_enterprise_qualification',
                component: () => import('@/views/enterprise_qualifications/index.vue'),
                meta: { permission: 'agents/enterprise_qualification' }
              },
              {
                path: 'receive_addresses',
                name: 'agent_receive_addresses',
                component: () => import('@/views/receive_addresses/index.vue'),
                meta: { permission: 'agents/receive_address' }
              },
              {
                path: 'agent_files',
                name: 'agent_files',
                component: () => import('@/views/agent_files/index.vue'),
                meta: { permission: 'agent_files' }
              },
              {
                path: 'customize_site',
                name: 'agent_customize_site',
                component: () => import('@/views/customize_site/index.vue'),
                meta: { permission: 'agents/customize_site' }
              },
              {
                path: 'operation_remarks',
                name: 'agent_operation_remarks',
                component: () => import('@/views/agents/info/OperationRemarks.vue'),
                meta: { permission: 'agents/customize_site' }
              }
            ]
          },
          {
            path: 'products',
            name: 'agent_products',
            component: () => import('@/views/agents_products/index.vue'),
            meta: { permission: 'agents_products' }
          },
          {
            path: 'esim_products',
            name: 'agent_esim_products',
            component: () => import('@/views/agents_esim_products/index.vue'),
            meta: { permission: 'agents_esim_products' }
          },
          {
            path: 'profile_products',
            name: 'agent_profile_products',
            component: () => import('@/views/agents_profile_products/index.vue'),
            meta: { permission: 'agents_profile_products' }
          },
          {
            path: 'module_products',
            name: 'agent_module_products',
            component: () => import('@/views/agents_module_products/index.vue'),
            meta: { permission: 'agents_module_products' }
          },
          {
            path: 'cpe_products',
            name: 'agent_cpe_products',
            component: () => import('@/views/agents_cpe_products/index.vue'),
            meta: { permission: 'agents_cpe_products' }
          },
          {
            path: 'sim_cards',
            name: 'agent_sim_cards',
            component: () => import('@/views/sim_cards/agent/index'),
            meta: { permission: 'sim_cards' }
          },
          {
            path: 'esims',
            name: 'agent_esims',
            component: () => import('@/views/esims/agent/index'),
            meta: { permission: 'agent_esims' }
          },
          {
            path: 'profiles',
            name: 'agent_profiles',
            component: () => import('@/views/profiles/agent/index'),
            meta: { permission: 'agent_profiles' }
          },
          {
            path: 'modules',
            name: 'agent_modules',
            component: () => import('@/views/modules/agent/index'),
            meta: { permission: 'agent_modules' }
          },
          {
            path: 'cpes',
            name: 'agent_cpes',
            component: () => import('@/views/cpes/agent/index'),
            meta: { permission: 'agent_cpes' }
          },
          {
            path: '',
            component: () => import('@/views/agents/finance/Tab'),
            children: [
              {
                path: 'finance',
                name: 'agent_finance',
                component: () => import('@/views/agents/finance/Overview'),
                meta: { permission: 'agents/finance' }
              },
              {
                path: 'monthly_bills',
                name: 'agent_monthly_bills',
                component: () => import('@/views/agent_monthly_bills/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_consumption_bills',
                name: 'agent_consumption_bills',
                component: () => import('@/views/agent_consumption_bills/index'),
                meta: { permission: 'agent_consumption_bills' }
              },
              {
                path: 'transfers',
                name: 'agent_transfers',
                component: () => import('@/views/transfers/agent/index'),
                meta: { permission: 'agents/transfers' }
              },
              {
                path: 'balance_statistics',
                name: 'agent_balance_statistics',
                component: () => import('@/views/balance_statistics/agent/index'),
                meta: { permission: 'agents/balance_statistics' }
              },
              {
                path: 'monthly_bills/:agent_monthly_bill_id',
                name: 'agent_monthly_bill_info',
                component: () => import('@/views/agent_monthly_bills/Show'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'card_use/:card_use_id',
                name: 'agent_monthly_bill_card_use_info',
                component: () => import('@/views/agent_monthly_bills/card_use/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_renew_order/:renew_order_id',
                name: 'agent_monthly_bill_renew_order_info',
                component: () => import('@/views/agent_monthly_bills/renew/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'stop/:stop_id',
                name: 'agent_monthly_bill_stop_info',
                component: () => import('@/views/agent_monthly_bills/stop/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_consumption_bills/renew_orders/:renew_order_id',
                name: 'agent_consumption_bill_renew_order_info',
                component: () => import('@/views/agent_consumption_bills/renew/show/index'),
                meta: { permission: 'agent_consumption_bills' }
              },
              {
                path: 'agent_active_order/:active_order_id',
                name: 'agent_monthly_bill_active_order_info',
                component: () => import('@/views/agent_monthly_bills/active/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_consumption_bills/active_orders/:active_order_id',
                name: 'agent_consumption_bill_active_order_info',
                component: () => import('@/views/agent_consumption_bills/active/show/index'),
                meta: { permission: 'agent_consumption_bills' }
              },
              {
                path: 'agent_subscribe_order/:subscribe_order_id',
                name: 'agent_monthly_bill_subscribe_order_info',
                component: () => import('@/views/agent_monthly_bills/subscribe/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_consumption_bills/subscribe_orders/:subscribe_order_id',
                name: 'agent_consumption_bill_subscribe_order_info',
                component: () => import('@/views/agent_consumption_bills/subscribe/show/index'),
                meta: { permission: 'agent_consumption_bills' }
              },
              {
                path: 'agent_subscribe_traffic_pool_order/:subscribe_traffic_pool_order_id',
                name: 'agent_monthly_bill_subscribe_traffic_pool_order_info',
                component: () => import('@/views/agent_monthly_bills/subscribe_traffic_pool/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_consumption_bills/subscribe_traffic_pool_orders/:subscribe_traffic_pool_order_id',
                name: 'agent_consumption_bill_subscribe_traffic_pool_order_info',
                component: () => import('@/views/agent_consumption_bills/subscribe_traffic_pool/show/index'),
                meta: { permission: 'agent_consumption_bills' }
              }
            ]
          },
          {
            path: '',
            component: () => import('@/views/agents/commission/Tab'),
            children: [
              {
                path: 'commission',
                name: 'agent_commission',
                component: () => import('@/views/agents/commission/Overview'),
                meta: { permission: 'agents/finance' }
              },
              {
                path: 'monthly_bills_commission',
                name: 'agent_monthly_bills_commission',
                component: () => import('@/views/agent_monthly_bills_commission/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'withdrawals',
                name: 'agent_withdrawals',
                component: () => import('@/views/withdrawals/agent/index'),
                meta: { permission: 'agents/withdrawals' }
              },
              {
                path: 'commission_statistics',
                name: 'agent_commission_statistics',
                component: () => import('@/views/commission_statistics/agent/index'),
                meta: { permission: 'agents/balance_statistics' }
              },
              {
                path: 'monthly_bills_commission/:agent_monthly_bill_id',
                name: 'agent_monthly_bill_info_commission',
                component: () => import('@/views/agent_monthly_bills_commission/Show'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'card_use_commission/:card_use_id',
                name: 'agent_monthly_bill_card_use_info_commission',
                component: () => import('@/views/agent_monthly_bills_commission/card_use/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_renew_order_commission/:renew_order_id',
                name: 'agent_monthly_bill_renew_order_info_commission',
                component: () => import('@/views/agent_monthly_bills_commission/renew/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_subscribe_order_commission/:subscribe_order_id',
                name: 'agent_monthly_bill_subscribe_order_info_commission',
                component: () => import('@/views/agent_monthly_bills_commission/subscribe/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              },
              {
                path: 'agent_active_order_commission/:active_order_id',
                name: 'agent_monthly_bill_active_order_info_commission',
                component: () => import('@/views/agent_monthly_bills_commission/active/show/index'),
                meta: { permission: 'agent_monthly_bills' }
              }
            ]
          },
          {
            path: 'purchase_orders',
            name: 'agent_self_purchase_orders',
            component: () => import('@/views/agent_purchase_orders/agent/index'),
            meta: { permission: 'agents/purchase_orders' }
          },
          {
            path: 'traffic_pools',
            name: 'agent_traffic_pools',
            component: () => import('@/views/traffic_pools/index')
          },
          {
            path: 'traffic_pools/:traffic_pool_id',
            component: () => import('@/views/traffic_pools/show/Tab'),
            children: [
              {
                path: 'info',
                name: 'agent_traffic_pool_info',
                component: () => import('@/views/traffic_pools/show/index')
              },
              {
                path: 'sim_cards',
                name: 'agent_traffic_pool_sim_cards',
                component: () => import('@/views/traffic_pools/sim_card/index')
              },
              {
                path: 'expand_records',
                name: 'agent_traffic_pool_expand_records',
                component: () => import('@/views/traffic_pools/expand_records/index')
              },
              {
                path: 'usage_orders',
                name: 'agent_traffic_pool_usage_orders',
                component: () => import('@/views/traffic_pools/usage_orders/index')
              }
            ]
          },
          {
            path: '',
            component: () => import('@/views/sim_cards/service_cycle_manage/Tab'),
            children: [
              {
                path: 'service_cycle_unexpired',
                name: 'service_cycle_unexpired',
                component: () => import('@/views/sim_cards/service_cycle_manage/service_cycle_unexpired/index'),
                meta: { permission: 'sim_cards/service_cycle_manage' }
              },
              {
                path: 'service_cycle_expired',
                name: 'service_cycle_expired',
                component: () => import('@/views/sim_cards/service_cycle_manage/service_cycle_expired/index'),
                meta: { permission: 'sim_cards/service_cycle_manage' }
              },
              {
                path: 'current_month_expect_cancel',
                name: 'current_month_expect_cancel',
                component: () => import('@/views/sim_cards/service_cycle_manage/current_month_expect_cancel/index'),
                meta: { permission: 'sim_cards/service_cycle_manage' }
              },
              {
                path: 'renewed',
                name: 'service_cycle_renewed',
                component: () => import('@/views/sim_cards/service_cycle_manage/renewed/index'),
                meta: { permission: 'sim_cards/service_cycle_manage' }
              },
              {
                path: 'canceled',
                name: 'service_cycle_canceled',
                component: () => import('@/views/sim_cards/service_cycle_manage/canceled/index'),
                meta: { permission: 'sim_cards/service_cycle_manage' }
              }
            ]
          },
          {
            path: 'agent_sms_templates',
            name: 'agent_sms_templates',
            component: () => import('@/views/agents_sms_templates/index.vue'),
            meta: { permission: 'agent_sms_templates' }
          },
          {
            path: 'agent_agencies',
            name: 'agent_agencies',
            component: () => import('@/views/agents/agencies/index.vue'),
            meta: { permission: 'agent_agencies' }
          }
        ]
      }
    ]
  },
  {
    path: '/base_products',
    component: BasicLayout,
    meta: { title: '基础套餐', menu: 'base_products' },
    children: [
      {
        path: '',
        name: 'base_products',
        component: () => import('@/views/base_products/index'),
        meta: { permission: 'base_products' }
      }
    ]
  },
  {
    path: '/base_esim_products',
    component: BasicLayout,
    meta: { title: '上架eSIM', menu: 'base_esim_products' },
    children: [
      {
        path: '',
        name: 'base_esim_products',
        component: () => import('@/views/base_esim_products/index'),
        meta: { permission: 'base_esim_products' }
      }
    ]
  },
  {
    path: '/base_profile_products',
    component: BasicLayout,
    meta: { title: '上架Profile', menu: 'base_profile_products' },
    children: [
      {
        path: '',
        name: 'base_profile_products',
        component: () => import('@/views/base_profile_products/index'),
        meta: { permission: 'base_profile_products' }
      }
    ]
  },
  {
    path: '/base_module_products',
    component: BasicLayout,
    meta: { title: '上架模组', menu: 'base_module_products' },
    children: [
      {
        path: '',
        name: 'base_module_products',
        component: () => import('@/views/base_module_products/index'),
        meta: { permission: 'base_module_products' }
      }
    ]
  },
  {
    path: '/base_cpe_products',
    component: BasicLayout,
    meta: { title: '上架CPE', menu: 'base_cpe_products' },
    children: [
      {
        path: '',
        name: 'base_cpe_products',
        component: () => import('@/views/base_cpe_products/index'),
        meta: { permission: 'base_cpe_products' }
      }
    ]
  },
  {
    path: '/agent_pre_orders',
    component: CustomStyleLayout,
    meta: { title: '预制订单', menu: 'agent_pre_orders' },
    children: [
      {
        path: '',
        name: 'agent_pre_orders',
        component: () => import('@/views/agent_pre_orders/index'),
        meta: { permission: 'agent_pre_orders' }
      }
    ]
  },
  {
    path: '/agent_purchase_orders',
    component: CustomStyleLayout,
    meta: { title: '订单管理', menu: 'agent_purchase_orders' },
    children: [
      {
        path: '',
        name: 'agent_purchase_orders',
        component: () => import('@/views/agent_purchase_orders/index'),
        meta: { permission: 'agent_purchase_orders' }
      }
    ]
  },
  {
    path: '/allocation_records',
    component: BasicLayout,
    meta: { title: '划拨批次记录', menu: 'allocation_records' },
    children: [
      {
        path: '',
        component: () => import('@/views/allocation_records/ShowTab.vue'),
        meta: { permission: 'allocation_records' },
        children: [
          {
            path: '',
            name: 'allocation_records',
            component: () => import('@/views/allocation_records/index'),
            meta: { permission: 'allocation_records', operation_type: 'allocate_cards_to_top_agent' }
          },
          {
            path: 'esims',
            name: 'allocation_records_esims',
            component: () => import('@/views/allocation_records/index'),
            meta: { permission: 'allocation_records', title: 'eSIM划拨', operation_type: 'allocate_esims_to_top_agent' }
          },
          {
            path: 'profiles',
            name: 'allocation_records_profiles',
            component: () => import('@/views/allocation_records/index'),
            meta: { permission: 'allocation_records', title: 'Profile划拨', operation_type: 'allocate_profiles_to_top_agent' }
          },
          {
            path: 'modules',
            name: 'allocation_records_modules',
            component: () => import('@/views/allocation_records/index'),
            meta: { permission: 'allocation_records', title: '模组划拨', operation_type: 'allocate_modules_to_top_agent' }
          },
          {
            path: 'cpes',
            name: 'allocation_records_cpes',
            component: () => import('@/views/allocation_records/index'),
            meta: { permission: 'allocation_records', title: 'CPE划拨', operation_type: 'allocate_cpes_to_top_agent' }
          }
        ]
      }
    ]
  },
  {
    path: '/allocation_records',
    component: CustomStyleLayout,
    meta: { title: '划拨批次记录', menu: 'allocation_records' },
    children: [
      {
        path: ':id/info',
        name: 'allocation_record_info',
        component: () => import('@/views/allocation_records/detail/index.vue'),
        meta: { title: '划拨批次详情', permission: 'allocation_records/show' }
      }
    ]
  },
  {
    path: '/roles',
    component: BasicLayout,
    meta: { title: '角色与权限', menu: 'roles' },
    children: [
      {
        path: '',
        name: 'roles',
        component: () => import('@/views/roles/index.vue'),
        meta: { permission: 'roles' }
      }
    ]
  },
  {
    path: '/users',
    component: BasicLayout,
    meta: { title: '用户管理', menu: 'users' },
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('@/views/users/index.vue'),
        meta: { permission: 'users' }
      }
    ]
  },
  {
    path: '/departments',
    component: BasicLayout,
    meta: { title: '部门管理', menu: 'departments' },
    children: [
      {
        path: '',
        name: 'departments',
        component: () => import('@/views/departments/index.vue'),
        meta: { permission: 'departments' }
      }
    ]
  },
  {
    path: '/base_carrier_products',
    component: BasicLayout,
    meta: { title: '运营商通用套餐', menu: 'base_carrier_products' },
    children: [
      {
        path: '',
        name: 'base_carrier_products',
        component: () => import('@/views/base_carrier_products/index'),
        meta: { permission: 'base_carrier_products' }
      }
    ]
  },
  {
    path: '/user_business_type_statistics',
    component: BasicLayout,
    meta: { title: '用户业务模式管理', menu: 'user_business_type_statistics' },
    children: [
      {
        path: '',
        name: 'user_business_type_statistics',
        component: () => import('@/views/user_business_type_statistics/index.vue'),
        meta: { permission: 'user_business_type_statistics' }
      }
    ]
  },
  {
    path: '/traffic_scenes',
    component: BasicLayout,
    meta: { title: '流量场景管理', menu: 'traffic_scenes' },
    children: [
      {
        path: '',
        name: 'traffic_scenes',
        component: () => import('@/views/traffic_scenes/index.vue'),
        meta: { permission: 'traffic_scenes' }
      }
    ]
  },
  {
    path: '/agreements',
    component: BasicLayout,
    meta: { title: '协议管理', menu: 'agreements' },
    children: [
      {
        path: '',
        name: 'agreements',
        redirect: 'platform_service',
        component: () => import('@/views/agreements/Tab'),
        meta: { permission: 'agreements' },
        children: [
          {
            path: 'platform_service',
            name: 'platform_service_agreements',
            component: () => import('@/views/agreements/platform_service/index.vue'),
            meta: { permission: 'agreements/platform_service' }
          },
          {
            path: 'card',
            name: 'card_agreements',
            component: () => import('@/views/agreements/card/index.vue'),
            meta: { permission: 'agreements/card' }
          }
        ]
      }
    ]
  },
  {
    path: '/api_interfaces',
    component: BasicLayout,
    meta: { title: '平台API管理', menu: 'api_interfaces' },
    children: [
      {
        path: '',
        name: 'api_interfaces',
        component: () => import('@/views/api_interfaces/index.vue'),
        meta: { permission: 'api_interfaces' }
      }
    ]
  },
  {
    path: '/sms_channels',
    component: BasicLayout,
    meta: { title: '短信接口管理', menu: 'sms_channels' },
    children: [
      {
        path: '',
        name: 'sms_channels',
        component: () => import('@/views/sms_channels/index.vue'),
        meta: { permission: 'sms_channels' }
      }
    ]
  },
  {
    path: '/sms_templates',
    component: BasicLayout,
    meta: { title: '短信模版管理', menu: 'sms_templates' },
    children: [
      {
        path: '',
        name: 'sms_templates',
        component: () => import('@/views/sms_templates/index.vue'),
        meta: { permission: 'sms_templates' }
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    meta: { title: '公告管理', menu: 'announcements' },
    children: [
      {
        path: 'announcements',
        name: 'announcements',
        component: () => import('@/views/announcements/index.vue'),
        meta: { permission: 'announcements' }
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    meta: { title: '通知消息', menu: '' },
    children: [
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('@/views/notifications/index.vue')
      }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    meta: { title: '导出管理', menu: '' },
    children: [
      {
        path: 'data_export_tasks',
        name: 'data_export_tasks',
        component: () => import('@/views/data_export_tasks/index.vue')
      }
    ]
  },
  {
    path: '/contracting_parties',
    component: BasicLayout,
    meta: { title: '签约主体', menu: 'contracting_parties' },
    children: [
      {
        path: '',
        name: 'contracting_parties',
        component: () => import('@/views/contracting_parties/index.vue'),
        meta: { permission: 'contracting_parties' }
      }
    ]
  },
  {
    path: '/express_senders',
    component: BasicLayout,
    meta: { title: '寄件信息管理', menu: 'express_senders' },
    children: [
      {
        path: '',
        name: 'express_senders',
        component: () => import('@/views/express_senders/index.vue'),
        meta: { permission: 'express_senders' }
      }
    ]
  },
  {
    path: '/registered_agents',
    component: BasicLayout,
    meta: { title: '注册账号审核', menu: 'registered_agents' },
    children: [
      {
        path: '',
        name: 'registered_agents',
        component: () => import('@/views/registered_agents/index'),
        meta: { permission: 'registered_agents' }
      },
      {
        path: ':id',
        name: 'registered_agent_info',
        component: () => import('@/views/registered_agents/Show'),
        meta: { title: ':registered_agent_name', permission: 'registered_agents' }
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: BasicLayout,
    children: [
      {
        path: ':id',
        name: 'user_info',
        component: () => import('@/views/users/personal_info/index'),
        meta: { title: '个人资料', permission: 'users/edit_self_info' }
      }
    ]
  },
  {
    path: '/cancel_card_manages',
    component: BasicLayout,
    meta: { title: '销卡管理', menu: 'cancel_card_manages' },
    children: [
      {
        path: '',
        name: 'cancel_card_manages',
        component: () => import('@/views/cancel_card_manages/index.vue'),
        meta: { permission: 'cancel_card_manages' }
      }
    ]
  },
  {
    path: '/cancel_card_manages',
    component: CustomStyleLayout,
    meta: { title: '销卡管理', menu: 'cancel_card_manages' },
    children: [
      {
        path: 'carrier_accounts/:id',
        name: 'carrier_accounts_expect_cancel_cards',
        component: () => import('@/views/cancel_card_manages/expect_cancel_card_list/index.vue'),
        meta: { title: ':carrier_account_name', permission: 'cancel_card_manages' }
      }
    ]
  },
  {
    path: '/card_service_manages',
    component: BasicLayout,
    meta: { title: '卡服务周期管理', menu: 'card_service_manages' },
    children: [
      {
        path: '',
        name: 'card_service_manages',
        redirect: 'unexpired',
        component: () => import('@/views/card_service_manages/ShowTab.vue'),
        meta: { permission: 'card_service_manages' },
        children: [
          {
            path: 'unexpired',
            name: 'card_service_manages_unexpired',
            component: () => import('@/views/card_service_manages/Unexpired.vue'),
            meta: { permission: 'card_service_manages/unexpired' }
          },
          {
            path: 'expired',
            name: 'card_service_manages_expired',
            component: () => import('@/views/card_service_manages/Expired.vue'),
            meta: { permission: 'card_service_manages/expired' }
          }
        ]
      }
    ]
  },
  {
    path: '/card_silent_manages',
    component: BasicLayout,
    meta: { title: '卡沉默期管理', menu: 'card_silent_manages' },
    children: [
      {
        path: '',
        name: 'card_silent_manages',
        redirect: 'unexpired',
        component: () => import('@/views/card_silent_manages/ShowTab.vue'),
        meta: { permission: 'card_silent_manages' },
        children: [
          {
            path: 'unexpired',
            name: 'card_silent_manages_unexpired',
            component: () => import('@/views/card_silent_manages/Unexpired.vue'),
            meta: { permission: 'card_silent_manages/unexpired' }
          },
          {
            path: 'expired',
            name: 'card_silent_manages_expired',
            component: () => import('@/views/card_silent_manages/Expired.vue'),
            meta: { permission: 'card_silent_manages/expired' }
          }
        ]
      }
    ]
  },
  {
    path: '/card_risk_manages',
    component: BasicLayout,
    meta: { title: '卡风险防控管理', menu: 'card_risk_manages' },
    children: [
      {
        path: '',
        name: 'card_risk_manages',
        redirect: 'bind_imei',
        component: () => import('@/views/card_risk_manages/ShowTab.vue'),
        meta: { permission: 'card_risk_manages' },
        children: [
          {
            path: 'bind_imei',
            name: 'card_risk_manages_bind_imei',
            component: () => import('@/views/card_risk_manages/BindImei.vue'),
            meta: { permission: 'card_risk_manages/bind_imei' }
          },
          {
            path: 'bind_area',
            name: 'card_risk_manages_bind_area',
            component: () => import('@/views/card_risk_manages/BindArea.vue'),
            meta: { permission: 'card_risk_manages/bind_area' }
          }
        ]
      }
    ]
  },
  {
    path: '/customer_service_manages',
    component: BasicLayout,
    meta: { title: '售后管理', menu: 'customer_service_manages' },
    children: [
      {
        path: '',
        name: 'customer_service_manages',
        redirect: 'issue',
        component: () => import('@/views/customer_service_manages/ShowTab.vue'),
        meta: { permission: 'customer_service_manages' },
        children: [
          {
            path: 'issue',
            name: 'customer_service_manages_issue',
            component: () => import('@/views/customer_service_manages/Issue.vue'),
            meta: { permission: 'customer_service_manages/issue' }
          }
        ]
      }
    ]
  }
]
